import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCRGzJfvP0Mg2Bih7vrqAq2igHkiSIpy_A",
  authDomain: "hiflow-71606.firebaseapp.com",
  projectId: "hiflow-71606",
  storageBucket: "hiflow-71606.firebasestorage.app",
  messagingSenderId: "176597515638",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const liveFirestore = firebase.firestore();
